// src/components/SalidaEntradaPatrones/SalidaEntrada.jsx
import React, { useState } from 'react';
import { Container, Nav, Navbar, Button, Badge } from 'react-bootstrap';
import {
  FaHome,
  FaPlus,
  FaUser,
  FaHistory,
  FaArrowLeft
} from 'react-icons/fa';
import Dashboard from './Dashboard';
import NuevaSalida from './NuevaSalida';
import MisMovimientos from './MisMovimientos';
import DetalleMovimiento from './DetalleMovimiento';
import HistorialPatron from './HistorialPatron';
import { useAuth } from '../../hooks/useAuth';

/**
 * Componente principal del módulo de Salida/Entrada de Patrones
 * Gestiona la navegación entre todas las vistas
 */
const SalidaEntrada = () => {
  const { userData } = useAuth();
  const [vistaActiva, setVistaActiva] = useState('dashboard');
  const [contextData, setContextData] = useState(null);

  // Handlers para navegación entre vistas
  const handleNavegar = (vista, data = null) => {
    setVistaActiva(vista);
    setContextData(data);
  };

  const handleVolverDashboard = () => {
    setVistaActiva('dashboard');
    setContextData(null);
  };

  // Handler para ver detalles de un movimiento
  const handleViewMovimiento = (movimiento) => {
    handleNavegar('detalle-movimiento', {
      groupConsecutive: movimiento.groupConsecutive,
      movimientoId: movimiento._id
    });
  };

  // Handler para ver historial de un patrón
  const handleViewHistorialPatron = (patron) => {
    handleNavegar('historial-patron', { patron });
  };

  // Handler cuando se crea exitosamente una salida
  const handleSalidaCreada = (data) => {
    // Navegar al detalle del grupo creado
    handleNavegar('detalle-movimiento', {
      groupConsecutive: data.groupConsecutive,
      movimientoId: data.movimientos[0]?._id
    });
  };

  // Renderizar todas las vistas pero solo mostrar la activa
  // Esto evita desmontar componentes y perder su estado
  const renderVistaActiva = () => {
    return (
      <>
        <div style={{ display: vistaActiva === 'dashboard' ? 'block' : 'none' }}>
          <Dashboard
            onViewMovimiento={handleViewMovimiento}
            onViewPatronHistorial={handleViewHistorialPatron}
          />
        </div>

        {vistaActiva === 'nueva-salida' && (
          <NuevaSalida
            onBack={handleVolverDashboard}
            onSuccess={handleSalidaCreada}
          />
        )}

        {vistaActiva === 'mis-movimientos' && (
          <MisMovimientos
            onViewDetails={handleViewMovimiento}
            onAgregarOt={(mov) => handleViewMovimiento(mov)}
            onCompletarOt={(mov) => handleViewMovimiento(mov)}
            onCerrarMovimiento={(mov) => handleViewMovimiento(mov)}
          />
        )}

        {vistaActiva === 'detalle-movimiento' && (
          <DetalleMovimiento
            groupConsecutive={contextData?.groupConsecutive}
            movimientoId={contextData?.movimientoId}
            onBack={handleVolverDashboard}
            onRefresh={() => {
              // Forzar recarga del dashboard también
            }} 
          />
        )}

        {vistaActiva === 'historial-patron' && (
          <HistorialPatron
            patron={contextData?.patron}
            onBack={handleVolverDashboard}
            onViewMovimiento={handleViewMovimiento}
          />
        )}

        {vistaActiva === 'historial-calendario' && (
          <div className="p-4">
            <h2 className="text-center text-muted">Próximamente: Historial por Calendario</h2>
            <p className="text-center text-muted">
              Estamos trabajando en esta funcionalidad para ofrecerte una vista completa de tus movimientos organizados por fechas.
            </p>
          </div>
        )}
      </>
    );
  };

  // Determinar si mostrar navegación
  const mostrarNavegacion = !['detalle-movimiento', 'historial-patron'].includes(vistaActiva);

  return (
    <div className="salida-entrada-patrones">
      {/* Barra de navegación superior */}
      {mostrarNavegacion && (
        <Navbar bg="light" expand="lg" className="mb-0 border-bottom shadow-sm">
          <Container fluid>
            <Navbar.Brand className="fw-bold text-primary">
              📦 Control de Patrones
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbar-salida-entrada" />
            <Navbar.Collapse id="navbar-salida-entrada">
              <Nav className="me-auto">
                <Nav.Link
                  active={vistaActiva === 'dashboard'}
                  onClick={() => handleNavegar('dashboard')}
                  className="d-flex align-items-center gap-2"
                >
                  <FaHome />
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  active={vistaActiva === 'mis-movimientos'}
                  onClick={() => handleNavegar('mis-movimientos')}
                  className="d-flex align-items-center gap-2"
                >
                  <FaUser />
                  Mis Equipos
                </Nav.Link>

                {/*Nav para moviemitnos por calendario, si se decide implementar*/}
                <Nav.Link
                  active={vistaActiva === 'historial-calendario'}
                  onClick={() => handleNavegar('historial-calendario')}
                  className="d-flex align-items-center gap-2"
                >
                  <FaHistory />
                  Historial Total 
                </Nav.Link>
              </Nav>

              <Nav>
                <Button
                  variant="primary"
                  onClick={() => handleNavegar('nueva-salida')}
                  className="d-flex align-items-center gap-2"
                >
                  <FaPlus />
                  Nueva Salida
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      {/* Breadcrumb para vistas de detalle */}
      {!mostrarNavegacion && (
        <div className="bg-light border-bottom py-2">
          <Container fluid>
            <Button
              variant="link"
              onClick={handleVolverDashboard}
              className="text-decoration-none p-0"
            >
              <FaArrowLeft className="me-2" />
              Volver al Dashboard
            </Button>
          </Container>
        </div>
      )}

      {/* Contenido principal */}
      <div className="vista-contenido">
        {renderVistaActiva()}
      </div>
    </div>
  );
};
export default SalidaEntrada;
